import Media from './media/media-tmpl'
import TemplateSet from './template-set/create-template-set-tmpl'
import ProjectTemplate from '../project-template/project-template-tmpl'
import ProjectAudio from '../project-audio/project-audio-tmpl'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'

const NEW_PROJECT_PAGE_CONTENT = 'new'
const AUDIO_PAGE_CONTENT = 'audio'
const MEDIA_ROUTE_NAME = 'media'

export default {
  name: 'mediaAndTemplatePage',
  inject: [
    '$currentUser'
  ],
  components: {
    Media,
    TemplateSet,
    ProjectTemplate,
    ProjectAudio
  },
  watch: {
    '$route.params' (newVal, prevVal) {
      this.handleChangePageContent(newVal.pageContent)
    }
  },
  mixins: [UnsavedDataMixin],
  data () {
    return {
      pageContent: 'template',
      isParentComponentMounted: false,
      pageContentOptions: { media: 'media', template: 'template', newProject: 'new', specialOccasionCovid19: 'covid-19', audio: 'audio' },
      mediaComponentAs: 'mediaFiles'
    }
  },
  computed: {
    inFilesRoute () {
      return this.$route.name === MEDIA_ROUTE_NAME
    }
  },
  methods: {
    handleChangePageContent (content) {
      if (!content) {
        this.pageContent = this.pageContentOptions.template
        return
      }

      const contents = [this.pageContentOptions.media, this.pageContentOptions.template, this.pageContentOptions.newProject, this.pageContentOptions.specialOccasionCovid19, this.pageContentOptions.audio]
      this.mediaComponentAs = 'mediaFiles'
      if (contents.indexOf(content) >= 0) {
        this.pageContent = content

        if (this.pageContent === this.pageContentOptions.specialOccasionCovid19) {
          this.mediaComponentAs = this.pageContentOptions.specialOccasionCovid19
        }

        // Audio contract
        if (this.pageContent === 'audio') {
          if (!this.$currentUser.hasGroupExtended()) {
            this.$router.push('/menu', () => {})
          }

          if (this.$currentUser.hasGroupExtended() && !this.$currentUser.hasGroupUserAdmin() && !this.$currentUser.hasGroupUserCreate() && !this.$currentUser.hasGroupUserCreateLock()) {
            this.$router.push('/menu', () => {})
          }
        }
      } else if (typeof content === 'string' && contents.indexOf(content) < 0) {
        this.pageContent = ''
      }
    }
  },
  mounted () {
    this.isParentComponentMounted = true
    this.handleChangePageContent(this.$route.params.pageContent)
  },
  beforeRouteLeave (_to, from, next) {
    // If from default create page(no pageContent value) OR custom, audio create page OR media page, check first for unsaved data before redirecting anywhere
    if (!from.params.pageContent || [NEW_PROJECT_PAGE_CONTENT, AUDIO_PAGE_CONTENT].includes(from.params.pageContent) || from.name === MEDIA_ROUTE_NAME) {
      this.checkUnsavedData({ nextAction: () => next() })
    } else {
      next()
    }
  },
  beforeRouteUpdate (_to, from, next) {
    // For redirects under the same root (in the case of this component, under '/create')
    if (!from.params.pageContent || [NEW_PROJECT_PAGE_CONTENT, AUDIO_PAGE_CONTENT].includes(from.params.pageContent) || from.name === MEDIA_ROUTE_NAME) {
      this.checkUnsavedData({ nextAction: () => next() })
    } else {
      next()
    }
  }
}
